import React from 'react';

import { IdleSessionTimeoutView } from './components';
import { useSessionTimeout } from './hooks';

export const IdleSessionTimeoutModal = () => {
    const props = useSessionTimeout();

    return (
        <IdleSessionTimeoutView {...props} />
    );
};

